import { configureStore } from '@reduxjs/toolkit';
import reducer from './Reducer';

const store = configureStore({
	reducer,
	devTools: true,
});

export default store;
